module.exports = __webpack_public_path__ + "static/media/icon_white_transparent.0a7011cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon_white_transparent.svg
// module id = 165
// module chunks = 0